module.exports = __webpack_public_path__ + "static/slider-7eb86c7ecb65a8c15cc8b0cdf410b8cd.gif";